module.exports = __webpack_public_path__ + "static/img/S.18187f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl/S.png
// module id = 1U2a
// module chunks = 0